import React from 'react';
import renderAsBackgroundImage from '~/libs/server/utils/renderAsBackgroundImage';
import ImageSection from '~/components/ui/ImageSection';
import { bgColorOption } from '~/components/ui/ImageSection/types';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

import shared from '~/styles/landingPageShared.module.less';
import imageSectionCSS from '~/components/ui/ImageSection/_imageSection--shared.module.less';
import css from '~/pages/wedding-registry/how-cash-gifts-work/cash.module.less';

const text = (
  <div className={imageSectionCSS.dek}>
    We recommend having guests contribute to specific experiences versus a bottomless pot.
  </div>
);
const image = (
  <>
    <div className={css.sectionImage3}>
      <span role="img" aria-label="image of a hiking experience" />
    </div>
    {renderAsBackgroundImage({
      selector: `.${css.sectionImage3}`,
      backgroundImageName: 'split',
      directory: 'CashGiftsLP/imageSections',
      filetype: ['png', 'png', 'png'],
      notVersioned: true,
    })}
  </>
);

/* ------------------------------------------------------------ */
const SplitFundImageSection: React.FC = () => (
  <>
    <ImageSection
      backgroundColor={bgColorOption.lightGray}
      className={shared.borderBottom}
      headerTag="h2"
      title="Split Large Funds Up"
      textPosition="right"
      secondaryContents={text}
      imageContents={image}
    />
    <div className={css.ctaContainer}>
      <LinkV2 arrow href="/shop/honeymoon-cash-funds">
        See All Honeymoon and Cash Funds
      </LinkV2>
    </div>
  </>
);

export default SplitFundImageSection;
